import Link from 'next/link';

import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import PropTypes from 'prop-types';

import { SectionHeader, TypedText } from '@/src/components/molecules';
import { HeroShaped } from '@/src/components/organisms';

const useStyles = makeStyles(theme => ({
  fontWeight600: {
    fontWeight: 600,
  },
  leftSideContent: {
    '& .section-header__cta-container': {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        '& .section-header__cta-item-wrapper': {
          width: '100%',
          '&:last-child': {
            marginLeft: 0,
            marginTop: theme.spacing(1),
          },
          '& .MuiButtonBase-root': {
            width: '100%',
          },
        },
      },
    },
  },
  heroShaped: {
    '& .hero-shaped__image': {
      backgroundColor: theme.palette.alternate.main,
    },
    [theme.breakpoints.down('sm')]: {
      '& .hero-shaped__image': {
        position: 'relative',
      },
      '& .hero-shaped__wrapper': {
        flexDirection: 'column',
      },
    },
  },
  imageAnimation: {
    background: `url("/images/illustrations/platform/hero.svg")`,
    backgroundRepeat: 'repeat',
    backgroundAttachment: 'scroll',
    backgroundSize: '300px auto',
    animation: `$slideshow 15s linear infinite`,
    width: '400%',
    height: '400%',
    backgroundColor: theme.palette.alternate.light,
    top: '-25%',
    left: '-100%',
    position: 'absolute',
    [theme.breakpoints.up('sm')]: {
      backgroundSize: '800px auto',
    },
  },
  imageAnimationDark: {},
  '@keyframes slideshow': {
    '0%': {
      transform: 'rotate(-13deg) translateY(-25%)',
    },
    '100%': {
      transform: 'rotate(-13deg) translateY(-60%)',
    },
  },
}));

const Hero = props => {
  const { themeMode = 'light', className, onLearnMore, ...rest } = props;

  const classes = useStyles();

  const title = (
    <Typography variant="h2" component="span" className={classes.fontWeight600}>
      Comece
      <br />
      <TypedText
        component="span"
        variant="h2"
        color="primary"
        className={classes.fontWeight600}
        typedProps={{
          strings: ['seu e-commerce', 'seu marketplace', 'a vender online'],
          typeSpeed: 50,
          loop: true,
        }}
      />
    </Typography>
  );

  const leftSideContent = (
    <SectionHeader
      title={title}
      subtitle="Com baixo investimento e rápida implantação, comece a vender online em uma plataforma customizada para venda de produtos e serviços educacionais"
      align="left"
      titleProps={{
        variant: 'h2',
        color: 'textPrimary',
      }}
      ctaGroup={[
        <Button
          size="large"
          variant="outlined"
          color="primary"
          onClick={onLearnMore}
          aria-label="Saiba mais"
          key="learnMoreCta">
          Saiba mais
        </Button>,
        <Link href="/schedule?utm_campaign=platform&utm_content=hero" passHref key="scheduleCta">
          <Button
            size="large"
            variant="contained"
            color="primary"
            component="a"
            aria-label="Agendar demonstração">
            Agendar demonstração
          </Button>
        </Link>,
      ]}
      data-aos="fade-right"
      disableGutter
      className={classes.leftSideContent}
    />
  );
  return (
    <div className={className} {...rest}>
      <HeroShaped
        className={classes.heroShaped}
        leftSide={leftSideContent}
        rightSide={
          <div
            className={clsx(
              classes.imageAnimation,
              themeMode === 'dark' ? classes.imageAnimationDark : '',
            )}
          />
        }
      />
    </div>
  );
};

Hero.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Theme mode
   */
  themeMode: PropTypes.string,
  /**
   * Learn more button
   */
  onLearnMore: PropTypes.func,
};

export default Hero;
